import React from 'react';
import { communityTestimonials, makerTestimonials } from '../data/testimonials';
import { Reveal } from './Reveal';
import { TestimonialCarousel } from './TestimonialCarousel';
import { CommunityMarquee } from './CommunityMarquee';
import { HookIcon, StarIcon } from './icons/CraftIcons';
export function MakerProof() {
  return <section aria-labelledby="maker-proof" className="w-full border-b border-hairline bg-cream px-4 py-10 sm:px-6 sm:py-14 lg:py-24" data-id="element-274" data-mp="1ghpjm73yflii">
      <div className="mx-auto max-w-[1120px]" data-id="element-275" data-mp="1qgwu8mjb121x">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-276" data-mp="1qfvew5v99tee">
          <span className="inline-flex items-center gap-2 rounded-full border border-gold/45 bg-gold-tint px-3 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-gold-dark" data-id="element-277" data-mp="248l56mhthkhb">
            <HookIcon className="h-3.5 w-3.5" data-id="element-278" data-mp="2e5zkujvx258k" />
            Real makers, real chicken bags
          </span>
          <h2 id="maker-proof" className="mt-4 font-display text-3xl font-bold leading-tight text-ink sm:text-[38px]" data-id="element-279" data-mp="297obsbdg3yre">
            This is what happens the first night you open the vault.
          </h2>
          <p className="mt-3 flex flex-wrap items-center justify-center gap-2 text-sm text-ink-soft" data-id="element-280" data-mp="3qvemcrwat55d">
            <span className="flex items-center gap-0.5 text-gold" data-id="element-281" data-mp="3vs4yx58w9im1">
              {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-4 w-4 fill-current" strokeWidth={1.2} data-id="element-282" data-mp="3r8czoy6eqy1" />)}
            </span>
            4.9 average from makers who started with the &ldquo;Chicken Bag&rdquo;
          </p>
        </Reveal>

        <Reveal delay={0.12} className="mt-6 sm:mt-9" data-id="element-283" data-mp="if1x9my7ihmy">
          <TestimonialCarousel items={makerTestimonials} labelledBy="maker-proof" data-id="element-284" data-mp="iflcux0dwtxt" />
        </Reveal>

        {/* Rolling community carousel — every photo with its own review */}
        <Reveal delay={0.18} data-id="element-285" data-mp="rgsyoflps2b0">
          <div className="mt-8 sm:mt-12" data-id="element-286" data-mp="rdey9cwm2367">
            <p id="community-marquee" className="mb-4 text-center text-[10px] font-extrabold uppercase tracking-[0.18em] text-ink-faint" data-id="element-287" data-mp="we1ggf2ya4bq">
              More from the community
            </p>
            <CommunityMarquee items={communityTestimonials} data-id="element-288" data-mp="2ohp373igjrhn" />
          </div>
        </Reveal>
      </div>
    </section>;
}